import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'prose sm:prose-sm max-w-none'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
